<template>
  <div>
    <v-menu center left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="handleClick(index)"
        >
          <v-list-item-icon>
            <v-icon :color="item.color">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title :style="{ color: item.color }"
            >{{ item.title }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="dialogs.delete = true">
          <v-list-item-icon>
            <v-icon color="#EC4A4A">mdi-trash-can</v-icon>
          </v-list-item-icon>
          <v-list-item-title style="color: #ec4a4a">Delete</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <DialogResend
      @close="dialogs.resend = false"
      v-if="dialogs.resend"
      :message="message"
    />
    <DialogDelete
      @close="dialogs.delete = false"
      v-if="dialogs.delete"
      :sent="sent"
    />
  </div>
</template>

<script>
import DialogResend from "../Dialogs/SentDialogResend";
import DialogDelete from "../Dialogs/SentDialogDelete";

export default {
  props: ["sent"],
  components: {
    DialogResend,
    DialogDelete,
  },
  data: () => ({
    dialogs: {
      resend: false,
      delete: false,
    },
    items: [
      {
        title: "Resend",
        icon: "mdi-send",
        color: "#142D3F",
        click() {
          this.dialogs.resend = true;
        },
      },
    ],
  }),
  methods: {
    toggleUserStatus(obj) {
      this.items.push(obj);
    },
    handleClick(index) {
      this.items[index].click.call(this);
    },
  },
};
</script>
